export const headers = [
  {
    name: 'Cliente',
    field: 'client.company_social_name',
    sortable: false
  },
  {
    name: 'Categoria',
    field: 'financialCategory.name',
    sortable: false
  },
  {
    name: 'Sub Categoria',
    field: 'financialSubCategory.name',
    sortable: false
  },
  { name: 'Vencimento', field: 'due_date', sortable: false },
  {
    name: 'Valor',
    field: 'value',
    sortable: false,

    hasTypes: {
      types: {
        monetary: {
          symbol: '',
          decimal: ',',
          separator: '.'
        }
      }
    }
  },
  {
    name: 'Pago',
    field: 'finished',
    sortable: false,
    hasTypes: {
      types: {
        S: 'Sim',
        N: 'Não',
        C: 'Cancelado'
      }
    }
  },
  {
    name: 'NF',
    field: 'nf_status',

    hasTypes: {
      types: {
        Wainting: 'Aguardando',
        Issued: 'Emitido',
        Canceled: 'Cancelado'
      }
    },
    sortable: false
  },
  { name: 'Gerado em', field: 'created_at', sortable: false },
  { name: 'Ações', field: 'actions', sortable: false }
]
